import store from '@/store/index.js'
import riaApiClient from "@/api";

const version = process.env.VUE_APP_API_VERSION;

export default {
  namespaced: true,
  state: {
    _customer: {}
  },
  getters: {
    customer: state => state._customer,
    participantById: state => id => state._customer.people.find(participant => participant.id === id),
  },
  actions: {
    async setCustomer(context, payload) {
      const response = await riaApiClient.get(`/api/${version}/resorts/${payload.resortid}/customers/${payload.customerid}`);

      store.commit('order/SET_ORDER_FIELD', {field: 'email', value: response.data.email});
      store.commit('order/SET_ORDER_FIELD', {field: 'customer_id', value: response.data.id});

      context.commit("SET_CUSTOMER", response.data);
    }
  },
  mutations: {
    SET_CUSTOMER(state, payload) {
        state._customer = payload;
    },
    SET_KEYCARD_SELECTION(state, payload) {
      if(state._customer.keycards){
        const index_keycard = state._customer.keycards.findIndex(keycard => keycard.number === payload.number)
        if(payload.unselected && index_keycard >= 0){
          delete state._customer.keycards[index_keycard].selected;
        }
        
        if (!payload.unselected && index_keycard >= 0){
          state._customer.keycards[index_keycard].selected = true;
        }
      }  
    },
    ADD_KEYCARD(state, keycard) {
      // mutate state
      if(!state._customer.keycards)state._customer.keycards = [];
      state._customer.keycards.push(keycard)
    },
    REMOVE_KEYCARD(state, payload) {
        const index_keycard = state._customer.keycards.findIndex(keycard => keycard.number === payload.number)
        state._customer.keycards.splice(index_keycard); 
    },
  }
};
